<div [ngSwitch]="position">
  <div
    *ngSwitchCase="'top-right'"
    [class]="'toast-container fixed ' + getZIndexClass() + ' ' + getPositionClasses()"
    @toastAnimation>
    <ng-container *ngTemplateOutlet="toastContent"></ng-container>
  </div>

  <div
    *ngSwitchCase="'bottom-center'"
    [class]="'toast-container fixed ' + getZIndexClass() + ' ' + getPositionClasses()"
    @toastAnimationBottom>
    <ng-container *ngTemplateOutlet="toastContent"></ng-container>
  </div>
</div>

<ng-template #toastContent>
  <div
    [class]="'toast-wrapper p-[16px] py-[24px] rounded-[8px] min-h-[36px] shadow-md text-gray-1200  flex-row gap-[12px] justify-between min-w-full text-[16px] flex items-center border border-gray-600 border-l-0 bg-white ' + borderClass()">

    <div class="flex flex-row items-center justify-center gap-[4px] flex-1">
      <NiFormIcon [icon]="getIcon()" iconClass="!w-[20px] !h-[20px]"  />
      <span class="text-gray-1200 font-archivo font-normal text-[16px] leading-[19px]">
        {{ message }}
      </span>
    </div>

    <NiFormIcon icon="closeToast" iconClass="!w-[20px] !h-[20px] cursor-pointer"  (click)="close()"   (keydown.enter)="close()"
  tabindex="0"/>

    <!-- Progress bar -->
    <div class="progress-bar-container absolute bottom-0 left-0 right-0 h-[3px] bg-gray-200 rounded-b-[8px] overflow-hidden">
      <div 
        class="progress-bar h-full transition-all ease-linear"
        [class]="type === 'success' ? 'bg-green-500' : type === 'info' ? 'bg-blue-500' : 'bg-red-500'"
        [style.width.%]="progressWidth">
      </div>
    </div>
  </div>
</ng-template>